import React, { FunctionComponent, type JSX } from "react";
import { TextInput, SingleLineTextInputProps } from "@narmi/design_system";
import { Tooltip } from "@narmi/design_system";

interface AccountNumberTextInputProps
  extends Pick<SingleLineTextInputProps, "value" | "onBlur" | "error" | "label" | "maxLength"> {
  onChange?: (value: string) => void;
  /** Form field name consumed by ContextForm.Field (cloneElement contract) */
  field?: string;
  tooltipText?: string;
}

const AccountNumberTextInput: FunctionComponent<AccountNumberTextInputProps> = ({
  onChange = () => {},
  value,
  onBlur = undefined,
  error,
  label = "Account number",
  maxLength = 0,
  tooltipText = "",
}): JSX.Element => {
  const handleInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value.replace(/[^\d]/g, ""));
  };

  return (
    <TextInput
      id="account_number"
      label={label}
      field="account_number"
      onChange={handleInput}
      onBlur={onBlur}
      value={value}
      error={error}
      maxLength={maxLength}
      endContent={
        tooltipText && (
          <Tooltip text={tooltipText}>
            <span className="narmi-icon-info" />
          </Tooltip>
        )
      }
    />
  );
};

export default AccountNumberTextInput;
